export const defaultUpColor = (mode: 'light' | 'dark') => (mode === 'dark' ? '#66bb6a' : '#2e7d32');
export const defaultDownColor = (mode: 'light' | 'dark') =>
  mode === 'dark' ? '#f44336' : '#d32f2f';
